import React from 'react';
import FlexGrid, { FlexGridColumn } from '../../../../components/FlexGrid';
import PaddingBox from '../../../../components/PaddingBox';
import { codes } from '../../../../data/translations';
import CheckboxAdapter from '../../../../components/adapters/form/Checkbox';
import AuthenticationActionButton from '../AuthenticationActionButton';
import { FormField } from '../../../../components/CustomForm';

export default ({ translate, disabled, onForgotPasswordClick }) => {
	return (
		<PaddingBox topTiny>
			<FlexGrid
				spaceBetween
				center
				wrap
			>
				<FlexGridColumn>
					<PaddingBox topTiny>
						<FormField
							component={CheckboxAdapter}
							name='rememberMe'
							controlProps={{ position: 'right', inline: true }}
							componentProps={{ label: translate(codes.user.rememberMe) }}
							disabled={disabled}
						/>
					</PaddingBox>
				</FlexGridColumn>
				<FlexGridColumn>
					<PaddingBox topTiny>
						<AuthenticationActionButton onClick={onForgotPasswordClick}>
							{translate(codes.user.forgotYourPassword)}
						</AuthenticationActionButton>
					</PaddingBox>
				</FlexGridColumn>
			</FlexGrid>
		</PaddingBox>
	);
};
